import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { useRouterActions } from 'react-resource-router';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { fg } from '@atlaskit/platform-feature-flags';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import { usePfErrorUtils } from '@atlassian/proforma-common-core/jira-common-context';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { useTemplateFormApi } from '../../../../../../services/template-form-api';
import { messages } from './messages';
export const DuplicateFormAction = ({
  form
}) => {
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const intl = useIntl();
  const {
    reportError
  } = usePfErrorUtils();
  const {
    push
  } = useRouterActions();
  const templateFormApi = useTemplateFormApi();
  const handleDuplicateForm = formToCopy => {
    templateFormApi.copyTemplateForm(formToCopy.id, form.projectId, form.projectId,
    // duplicating to same project
    intl.formatMessage(messages.copyNewFormName, {
      formName: formToCopy.name
    })).then(response => {
      if (fg('proforma_add_project_form_analytics')) {
        fireTrackAnalytics(createAnalyticsEvent({}), `${ActionSubject.FORM} ${Action.COPIED}`, {
          templateFormId: formToCopy.id,
          projectCopiedFromId: form.projectId,
          projectCopiedToId: form.projectId
        });
      }
      push(response.nextUrl);
    }).catch(error => {
      if (fg('proforma_add_project_form_analytics')) {
        reportError(error, {
          id: 'copyForm'
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: () => handleDuplicateForm(form)
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.duplicateLabel));
};